import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const BookingPriceAdjustments = ({ adjustmentContracts, currency }) => {
  const sortedAdjustments = sortBy(adjustmentContracts, 'meta.info.category');

  return (
    <div data-testing-id='booking-price-adjustments'>
      {sortedAdjustments
        .filter((adjustment) => {
          const adjustmentInfo = adjustment.meta?.info || {};
          // only show overtime or damages
          return (
            adjustmentInfo.category === 'OVERTIME' ||
            adjustmentInfo.category === 'DAMAGES'
          );
        })
        .map((adjustment) => {
          const adjustmentInfo = adjustment.meta?.info || {};
          return (
            <div className='flex space-between middle'>
              <span data-testing-id='booking-price-adjustments-label'>
                {adjustmentInfo.category === 'OVERTIME' ? (
                  <FormattedMessage
                    id='inbox.contract_calculator.overtime'
                    defaultMessage='Overtime'
                  />
                ) : (
                  <FormattedMessage
                    id='inbox.contract_calculator.damages'
                    defaultMessage='Damages'
                  />
                )}
              </span>
              <span data-testing-id='booking-price-adjustments-amount'>
                <FormattedNumber
                  value={adjustmentInfo.amount || 0}
                  currency={currency}
                  style='currency'
                />
              </span>
            </div>
          );
        })}
    </div>
  );
};

BookingPriceAdjustments.propTypes = {
  adjustmentContracts: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.string.isRequired
};
